import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './Text.scss';

class Text extends Component {
  state = {
    reRenderText: false
  };

  componentWillReceiveProps(nextProps) {
    const { reRenderText } = this.state;

    if (this.props.value !== nextProps.value) {
      this.setState({ reRenderText: !reRenderText });
    }
  }

  render() {
    const {
      value,
      number,
      invert,
      center,
      focused,
      reverseOrder,
      shrinkContent
    } = this.props;

    return (
      (value || number) && (
        <div
          className={`${styles.Text}
          ${invert ? styles.invert : ''}
          ${center ? styles.center : ''}
          ${focused ? styles.focused : ''}
          ${value === '@invisible' ? styles.invisible : ''}`}
        >
          {number && <span className={`${reverseOrder ? styles.back : ''}`}>{number}</span>}
          {value &&
            <span className={`
              ${shrinkContent ? styles.shrink : ''}
              ${this.state.reRenderText ? styles.reRenderText : ''}
              `}
            >
              {value}
            </span>}
        </div>
      )
    );
  }
}

Text.defaultProps = {
  value: '',
  number: '',
  invert: false,
  center: false,
  focused: false,
  reverseOrder: false,
  shrinkContent: false
};

Text.propTypes = {
  value: PropTypes.string,
  number: PropTypes.string,
  invert: PropTypes.bool,
  center: PropTypes.bool,
  focused: PropTypes.bool,
  reverseOrder: PropTypes.bool,
  shrinkContent: PropTypes.bool
};

export default Text;



// WEBPACK FOOTER //
// ./src/components/Text/Text.js